import { getDocs, collection } from 'firebase/firestore'
import { database } from '../firebase'
import type { PartBrand } from '@/types'

export const getPartBrands = async (): Promise<PartBrand[]> => {
  try {
    const ref = collection(database, 'part_brands')
    const snapshot = await getDocs(ref)
    if (snapshot.empty) return []
    return snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id } as PartBrand))
  } catch (error) {
    console.error('Error al obtener marcas de repuestos:', error)
    return []
  }
}
